/**
 * Vacancy List - Component script
 *
 * Uses FilterManager utility for multi-filter functionality
 */

import { FilterManager, type FilterConfig } from '../utils/filterManager';

interface VacancyListConfig {
    readonly componentId: string;
    readonly showMoreText: string;
    readonly showLessText: string;
}



/**
 * Initializes the vacancy list filtering logic.
 */
function initVacancyList(config: VacancyListConfig): void {
    const filterConfig: FilterConfig = {
        containerSelector: `.mp-component-id-${config.componentId}`,
        itemSelector: '.list-container a',
        filterSelectors: [
            'select[name="departmentSelect"]',
            'select[name="locationSelect"]',
            'select[name="typeSelect"]'
        ],
        loadMoreSelector: '.show-more',
        noResultsSelector: '.no-vacancies',
        initialLimit: 5,
        visibleClass: 'visible',
        showAllClass: 'show-all',
        showMoreText: config.showMoreText,
        showLessText: config.showLessText
    };

    new FilterManager(filterConfig);
}

/**
 * Entry point: Finds all vacancy components on the page and initializes them individually.
 */
document.addEventListener('DOMContentLoaded', () => {
    const vacancyComponents = document.querySelectorAll<HTMLElement>('[data-vacancy-list-config]');

    vacancyComponents.forEach((element) => {
        const configData = element.dataset.vacancyListConfig;

        if (configData) {
            try {
                const config = JSON.parse(configData) as VacancyListConfig;
                initVacancyList(config);
            } catch (error) {
                console.error('VacancyList: Failed to parse configuration JSON.', error);
            }
        }
    });
});

export { initVacancyList };